










































import Vue from 'vue'
import Navigation from '@/components/common/Navigation.vue'

export default Vue.extend({
  components: {
    Navigation
  },
  computed: {
    device() {
      return this.$store.getters.device
    },
    newMobileScreens(): boolean {
      return this.$store.getters.newMobileScreens
    }
  },
  methods: {
    backCallback() {
      this.$router.push({ name: 'library-v2' })
    }
  }
})
